var errorsHandled = [
    "9002",
    "9003",
    "9004",
    "9005",
    "INCORRECT_NAME",
    "INCORRECT_TIME",
    "INCORRECT_COMMAND",
    "OTHER_CYCLE"
];

export default errorsHandled;